import { render, staticRenderFns } from "./plan-create.vue?vue&type=template&id=51600447&scoped=true&"
import script from "./plan-create.vue?vue&type=script&lang=js&"
export * from "./plan-create.vue?vue&type=script&lang=js&"
import style0 from "./plan-create.vue?vue&type=style&index=0&id=51600447&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51600447",
  null
  
)

export default component.exports